
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dr-smile-universal-form",
      function () {
        return require("private-next-pages/dr-smile-universal-form.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dr-smile-universal-form"])
      });
    }
  